/**
 * @fileoverview Hook para verificar status dos dados contextuais no Redux.
 * Com globalData slice, a hidratação é automática — este hook apenas reporta status.
 *
 * @module useContextualData
 * @since 2.0.0
 */

import { useSelector } from 'react-redux';
import { selectProducts } from '../store/slices/globalDataSlice';

/**
 * Hook para verificar status dos dados contextuais.
 * @returns {Object} Estado dos dados contextuais
 */
export function useContextualData() {
  const products = useSelector(selectProducts);

  return {
    isDataLoaded: products.length > 0,
    productsCount: products.length,
  };
}

export default useContextualData;
 